import {Injectable} from '@angular/core';

@Injectable()
export class NgxAdDfpService {

  public static areAdsDefined = false;

  constructor() {

  }

  /**
   * Define Slots used for the ads to display
   * @param settings Settings set by JSON file
   * @param googletag The googletag declared by google's script included in index.html
   *
   */
  public static defineAds(googletag: any): void {
    if (!this.areAdsDefined) {
      let gptAdSlots: any[] = [];

      googletag.cmd.push(() => {
        googletag.pubads().enableSingleRequest();

        googletag.defineSlot('/308402/b.apa.tmus/dictionary', [300, 250], 'div-gpt-ad-1582927165062-0').addService(googletag.pubads());
        googletag.defineSlot('/308402/b.apa.tmus/dictionary', [300, 250], 'div-gpt-ad-1582927165035-0').addService(googletag.pubads());
        googletag.defineSlot('/308402/b.apa.tmus/dictionary', [300, 250], 'div-gpt-ad-1582927165042-0').addService(googletag.pubads());
        

        // Init ad service
        googletag.enableServices();
      });
    }
    this.areAdsDefined = true;
  }
}


// WEBPACK FOOTER //
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/app/model/ngx-ad-dfp-service.ts